export const areas = {
  header: "header",
  sidebar: "sidebar"
};
